import React, { useState, useEffect } from "react";
import { useAuth } from "../../Utils/Auth";
import AccountService from "../../Services/AccountService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  faEdit,
  faTrashAlt,
  faPlus,
  faFileAlt,
  faMinus,
  faEye,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import GridCard from "../../common/gridCard";
import SingleCard from "../../common/singleCard";
import "./index.css";
import { customErrorHandler, toTitleCase } from "../../Utils/helper";
import EditWebsite from "../../Component/Modal/EditWebsite";
import FullScreenLoader from "../../Component/FullScreenLoader";
import NewPagination from "../../Component/DashBoard/NewPagination";
import Confirmation_dialog from "../../Component/confirmation_dialog";
import Website_Service from "../../Services/apiService/website-service";
import AddWebsiteBalance from "./balance/add_balance/index";
import WithdrawWebsiteBalance from "./balance/withdraw_balance/index";
import RenewPermission from "../../Component/edit_permission";
import websiteService from "../../Services/apiService/website-service";
import WebsiteTransactionView from "./transactionView";
import AddEditWebsite from "./add-edit/index";
const Website = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [getWebsite, setGetWebsite] = useState([]);
  const [SId, setSId] = useState();
  const [SubAdmins, setSubAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [search, setSearch] = useState(""); // usestate for search state
  const [response, setResponse] = useState({});
  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [showAddDialog, setShowAddDialog] = useState({
    show: false,
    data: "",
  });
  const [permissionToggle, setPermissionToggle] = useState(true); // need to do false while close

  const [showWithdrawDialog, setShowWithdrawDialog] = useState({
    show: false,
    data: "",
  });
  const [renderParrent, setRenderParrent] = useState(null);

  const pageLimit = 9;

  const confirmDialogInitialState = {
    show: false,
    title: "",
    message: "",
    confirmText: "",
    cancelText: "",
    isConfirm: false,
    isDenied: false,
    data: "",
    onSuccess: () => {},
  };
  const [showConfirmDialog, setShowConfirmDialog] = useState(
    confirmDialogInitialState
  );

  const [showPermissionDialog, setShowPermissionDialog] = useState(false);

  const [addEditDialogData, setAddEditDialogData] = useState({
    id: "",
    callingFor: "",
    dialogTitle: "",
    data: {},
  });
  const [showAddEdit, setShowAddEdit] = useState(false);
  const [formData, setFormData] = useState({
    websiteName: "",
  });

  const selectPageHandler = (selectedPage) => {
    console.log(selectedPage);
    setPage(selectedPage);
  };

  const startIndex = Math.min((page - 1) * pageLimit + 1);
  const endIndex = Math.min(page * pageLimit, totalData);

  const handleCardClick = (id) => {
    setActiveCard(id);
    setTimeout(() => setActiveCard(null), 300); // Reset the animation class after animation duration
  };

  const handleSearch = (event) => {
    setPage(1);
    setSearch(event.target.value);
    if (!event.target.value) {
      setGetWebsite([]);
    }
  };

  const handeldeletewebsite = (id) => {
    console.log("Im here in line 94");
    AccountService.deletewebsite({ requestId: id }, auth.user)
      .then((res) => {
        console.log("res=>>>>", res);
        if (res.status === 201) {
          toast.success(res.data.message);
          setResponse(res.data);
        }
      })
      .catch((error) => {
        toast.error(customErrorHandler(error));
      });
  };

  // get api  fetch
  useEffect(() => {
    fetchData();
  }, [page, debouncedSearch, renderParrent]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearch(search);
    }, 300);

    return () => {
      clearTimeout(timerId);
    };
  }, [search]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await Website_Service.getWebsiteDetails(
        auth.user,
        page,
        search,
        pageLimit
      );
      const data = res?.data?.data.filter((item)=> item.isView !== 0)
      setGetWebsite(data);
      if(data?.length){
      setTotalData(res?.data?.pagination?.totalItems);
      setTotalPage(res?.data?.pagination?.totalPages);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handelstatement = (e, websitename) => {
    console.log("Website=>>>133", websitename);
    navigate(`/websitestatement/${websitename}`);
  };

  const handelActiveWebsite = (id) => {
    const flag = true;
    const data = {
      isActive: flag,
    };
    Website_Service.activeInactiveWebsite(id, data, auth.user)
      .then((response) => {
        toast.success(response.data.message || "Website Activated");
        const updatedWebsites = getWebsite.map((website) => {
          if (website.websiteId === id) {
            return {
              ...website,
              isActive: 1,
            };
          }
          return website;
        });
        setGetWebsite(updatedWebsites);
      })
      .catch((error) => {
        console.error(error);
        toast.error(customErrorHandler(error));
      });
  };

  const handelInactiveWebsite = (id) => {
    const flag = false;
    const data = {
      isActive: flag,
    };
    Website_Service.activeInactiveWebsite(id, data, auth.user)
      .then((response) => {
        // toast.success("Website Inactivated");
        toast.success(response?.data?.message || "Website Inactivated");
        const updatedWebsites = getWebsite.map((website) => {
          if (website.websiteId === id) {
            return {
              ...website,
              isActive: 0,
            };
          }
          return website;
        });

        setGetWebsite(updatedWebsites);

        console.log(response.data);
      })
      .catch((error) => {
        toast.error(customErrorHandler(error));
        console.error(error);
      });
  };

  const handelPermissionDialogOpen = (subAdmins, id) => {
    setSubAdmins(subAdmins);
    setSId(id);
    setShowPermissionDialog(true);
  };

  const handleConfirmDialogClose = () => {
    setShowConfirmDialog(confirmDialogInitialState);
  };

  const handleConfirmDialogOpen = (
    message,
    confirmText,
    cancelText,
    data,
    onConfirm
  ) => {
    setShowConfirmDialog((state) => ({
      ...state,
      show: true,
      message: toTitleCase(message),
      confirmText: confirmText,
      cancelText: cancelText,
      data: data,
      onSuccess: onConfirm,
    }));
  };

  const handleCloseAddDialog = () => {
    setShowAddDialog((state) => ({
      ...state,
      show: false,
    }));
  };
  const handleCloseWithdrawDialog = () => {
    setShowWithdrawDialog((state) => ({
      ...state,
      show: false,
    }));
  };
  const handleOpenAddDialog = (data) => {
    setShowAddDialog((state) => ({
      ...state,
      show: true,
      data: data,
    }));
  };

  const handleOpenWithdrawDialog = (data) => {
    setShowWithdrawDialog((state) => ({
      ...state,
      show: true,
      data: data,
    }));
  };

  const submitPermissionChange = (data, id) => {
    websiteService
      .permissionRenewWebsite(data, id, auth.user)
      .then((response) => {
        toast.success(toTitleCase(response.data.message || "Success"));
        // const getbankNameUpdated = JSON.parse(JSON.stringify(getWebsite));
        // getbankNameUpdated.forEach((item) => {
        //   if (item.websiteId === id) {
        //     item.subAdmins = data.subAdmins;
        //   }
        // });
        // setGetWebsite(getbankNameUpdated);
        setRenderParrent(response.data);
        handleClosePermissionDialog();
      })
      .catch((error) => {
        console.error(error);
        toast.error(toTitleCase(customErrorHandler(error)));
      });
  };

  const handleClosePermissionDialog = () => {
    setShowPermissionDialog(false);
    setPermissionToggle(true);
  };

  const handleAddWebsite = () => {
    setAddEditDialogData((prev) => ({
      ...prev,
      callingFor: "Add",
      dialogTitle: "Add New Website",
    }));
    setShowAddEdit(true);
  };

  const handleEditWebsite = (data) => {
    setFormData((prev) => ({
      ...prev,
      websiteName: data?.websiteName,
    }));
    setShowAddEdit(true);
    setAddEditDialogData((prev) => ({
      ...prev,
      id: data.websiteId,
      callingFor: "Edit",
      dialogTitle: "Edit Website",
      data: data,
    }));
  };

  const handleAddEditModalClose = () => {
    setFormData({
      websiteName: "",
    });
    setShowAddEdit(false);
  };


const handleAddEditSubmit = () => {
  setIsLoading(true);
  if (addEditDialogData.callingFor === "Add") {
    websiteService
      .addWebsite(formData, auth.user)
      .then((res) => {
        if (res) {
          toast.success(toTitleCase(res?.data?.message));
          handleAddEditModalClose();
        }
      })
      .catch((err) => {
        toast.error(toTitleCase(customErrorHandler(err)));
      })
      .finally(() => {
        setIsLoading(false);
      });
  } else {
    websiteService
      .editWebsite(formData, addEditDialogData.id, auth.user)
      .then((response) => {
        toast.success(toTitleCase(response?.data?.message));
        handleAddEditModalClose();
      })
      .catch((error) => {
        toast.error(toTitleCase(customErrorHandler(error)));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }
};


  return (
    <div className="bg-white">
      <div
        className="card text-center mt-2 mr-5 ml-5"
        style={{
          backgroundColor: "#e6f7ff",
          position: "relative",
        }}
      >
        <FullScreenLoader show={isLoading} />

        <SingleCard
          style={{
            backgroundColor: "#e6f7ff",
            position: "relative",
          }}
        >
          <div className="card-header-pill  text-bold d-flex ">
            <div className="flex-grow-1 ">
              <input
                type="text"
                className="form-control rounded-pill shadow"
                placeholder="Search Website"
                value={search}
                onChange={handleSearch}
              />
            </div>
            <div className="flex-grow-1 d-flex justify-content-end position-relative">
             <h5
                className="mr-5"
                style={{
                  color: "#B0A295", // Matching the background color of the button
                  fontSize: "1.5rem", // Adjust the size to fit well within the header
                  margin: "0", // Remove default margin
                  lineHeight: "2.5rem", // Align vertically with the button
                  fontWeight: "bold", // Make the text thicker
                  fontFamily: "'Abril Fatface', serif ",
                }}
              >
                Add Website
              </h5>
              <div
                className="input-icon position-absolute top-50 translate-middle-y d-flex align-items-center justify-content-center rounded-circle"
                onClick={handleAddWebsite} 
                style={{
                  width: "2.5rem",
                  height: "2.5rem",
                  backgroundColor: "#4682b4",
                  color: "#fff",
                  cursor: "pointer",
                  borderRadius: "50%",
                }}
              >
                <FontAwesomeIcon icon={faPlus} />
              </div>
            </div>
          </div>
        </SingleCard>
        <div className="card-body mt-2 mb-3 padding">
          <SingleCard className="mb-2 p-4">
            <br />
            <GridCard columns={2}>
              {getWebsite.map((data) => {
                const isInactive = !data.isActive;
                return (
                  <div
                    key={data.websiteId}
                    className="col d-flex justify-content-center align-items-center"
                    onMouseEnter={() => setHoveredCard(data.websiteId)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <div
                      className={`card d-flex justify-content-between ${
                        hoveredCard === data.websiteId
                          ? "card-hover-highlight"
                          : ""
                      }`}
                      style={{
                        borderRadius: "20px",
                        height: "200px",
                        width: "100%",
                        position: "relative",
                      }}
                      onClick={() => handleCardClick(data.websiteId)}
                    >
                      <div className="card-body">
                        <p
                          className="font-weight-bold fs-4 text-truncate"
                          style={{ color: "#708090" }}
                        >
                          {data.websiteName}
                          <br />
                          <span
                            className="fs-5 text-truncate"
                            style={{ color: "#A9A9A9" }}
                          >
                            Balance: {data.balance}
                          </span>
                        </p>
                        <div className="container">
                          <div className="row g-1 justify-content-center mt-5">
                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className={`btn btn-steel-blue btn-sm btn-hover-zoom ${
                                  data.isWithdraw && !isInactive
                                    ? ""
                                    : "avoid-clicks"
                                }`}
                                onClick={() => {
                                  handleOpenWithdrawDialog(data.websiteId);
                                }}
                                title="Withdraw"
                              >
                                <FontAwesomeIcon
                                  icon={faMinus}
                                  className="add-icon"
                                />
                              </button>
                            </div>
                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className={`btn btn-steel-blue btn-sm btn-hover-zoom ${
                                  data.isDeposit && !isInactive
                                    ? ""
                                    : "avoid-clicks"
                                }`}
                                onClick={() => {
                                  handleOpenAddDialog(data.websiteId);
                                }}
                                title="Deposit"
                              >
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  className="add-icon"
                                />
                              </button>
                            </div>
                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className="btn btn-custom btn-sm btn-zoom-out"
                                onClick={(e) => {
                                  handelstatement(e, data.websiteId);
                                }}
                                // onClick={()=>{setShowTransactionPage()}}
                                title="Statement"
                              >
                                <FontAwesomeIcon
                                  icon={faFileAlt}
                                  className="add-icon"
                                />
                              </button>
                            </div>

                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className={`btn btn-steel-blue btn-sm btn-hover-zoom ${
                                  data.isEdit && !isInactive
                                    ? ""
                                    : "avoid-clicks"
                                }`}
                                onClick={() => {
                                  handleEditWebsite(data);
                                }}
                                title="Edit Website"
                              >
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  data-toggle="modal"
                                  data-target="#exampleModalCenter"
                                />
                              </button>
                            </div>
                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className={`btn btn-steel-blue btn-sm btn-hover-zoom ${
                                  data.isDelete ? "" : "avoid-clicks"
                                }`}
                                onClick={(e) => {
                                  handleConfirmDialogOpen(
                                    "are you sure you want to delete this website ?",
                                    "Yes",
                                    "Cancel",
                                    data.websiteId,
                                    handeldeletewebsite
                                  );
                                }}
                                title="Delete"
                              >
                                <FontAwesomeIcon
                                  icon={faTrashAlt}
                                  className="delete-icon"
                                />
                              </button>
                            </div>

                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className={`btn btn-steel-blue btn-sm btn-hover-zoom ${
                                  data.isRenew && !isInactive
                                    ? ""
                                    : "avoid-clicks"
                                }`}
                                onClick={() => {
                                  handelPermissionDialogOpen(
                                    data.subAdmins,
                                    data.websiteId
                                  );
                                }}
                                title="Renew Permission"
                              >
                                <FontAwesomeIcon
                                  icon={faEye}
                                  className="permission"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-top-right">
                        {data.isActive === 1 ? (
                          <span
                            type="button"
                            className="badge-pill badge-success   btn-zoom-out-custom   "
                            title="Click To Inactive"
                            onClick={() => {
                              handleConfirmDialogOpen(
                                "are you sure you want to inactive this website ?",
                                "Yes",
                                "Cancel",
                                data.websiteId,
                                handelInactiveWebsite
                              );
                            }}
                          >
                            Active
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="active-icon ms-1 "
                            />
                            {/* <span className="dot dot-green position-absolute top-0 start-100 translate-middle"></span> */}
                          </span>
                        ) : (
                          // <span class="badge badge-pill badge-success">Success</span>
                          <span
                            type="button"
                            className="badge-pill badge-secondary  btn-zoom-out-custom "
                            title="Click To Active"
                            onClick={() => {
                              handleConfirmDialogOpen(
                                "are you sure you want to active this website ?",
                                "Yes",
                                "Cancel",
                                data.websiteId,
                                handelActiveWebsite
                              );
                            }}
                          >
                            Inactive
                            <FontAwesomeIcon
                              icon={faTimesCircle}
                              className="active-icon ms-1"
                            />
                            {/* <span className="dot dot-red dot-merged position-absolute top-0 start-100 translate-middle"></span> */}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </GridCard>
              { getWebsite.length === 0 && 
              <div className="d-flex justify-content-center align-items-center text-danger">No Websites Found</div>
               }
            {getWebsite.length > 0 && (
              <NewPagination
                currentPage={page}
                totalPages={totalPage}
                handlePageChange={selectPageHandler}
                startIndex={startIndex}
                endIndex={endIndex}
                totalData={totalData}
              />
            )}
          </SingleCard>
        </div>

        <AddWebsiteBalance
          state={showAddDialog}
          renderParent={setRenderParrent}
          setPage={setPage}
          handleClose={handleCloseAddDialog}
        />

        <WithdrawWebsiteBalance
          state={showWithdrawDialog}
          renderParent={setRenderParrent}
          setPage={setPage}
          handleClose={handleCloseWithdrawDialog}
        />

        <AddEditWebsite
          show={showAddEdit}
          handleClose={() => handleAddEditModalClose()}
          addEditDialogData={addEditDialogData}
          setFormData={setFormData}
          formData={formData}
          handleSubmit={handleAddEditSubmit}
        />

        <RenewPermission
          SubAdmins={SubAdmins}
          ID={SId}
          state={getWebsite}
          setState={setGetWebsite}
          show={showPermissionDialog}
          handleClose={handleClosePermissionDialog}
          onSubmit={submitPermissionChange}
          toggle={permissionToggle}
          setToggle={setPermissionToggle}
        />
        <Confirmation_dialog
          show={showConfirmDialog.show}
          title={showConfirmDialog.title}
          message={showConfirmDialog.message}
          confirmText={showConfirmDialog.confirmText}
          cancelText={showConfirmDialog.cancelText}
          state={showConfirmDialog}
          onSuccess={showConfirmDialog.onSuccess}
          handleConfirmDialogClose={handleConfirmDialogClose}
        />
        {/* <WebsiteTransactionView show={showTransactionPage}/> */}
      </div>
    </div>
  );
};

export default Website;
